export const APP_SECTIONS = [
    { id: "spamassassin", label: "Spam Filter", enabled: true },
    { id: "sieve", label: "Server Filters", enabled: true },
    { id: "archiving", label: "Archiving", enabled: true },
];
export { renderSieveSection } from "./sieve.js";
export { renderArchivingSection } from "./archiving/index.js";
